import Title from '@cohort/components-xps/components/Title';
import {classNames} from '@cohort/shared-frontend/utils/classNames';
import SecondaryButton from '@cohort/wallet/components/button/SecondaryButton';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import {trackError} from '@cohort/wallet/lib/Tracking';
import {Check, DownloadSimple} from '@phosphor-icons/react';
import type {FC} from 'react';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

type WalletAddressCopyProps = {
  address: string;
  handleImportNftClick: () => void;
};

export const WalletAddressCopy: FC<WalletAddressCopyProps> = ({address, handleImportNftClick}) => {
  const [addressCopied, setAddressCopied] = useState(false);
  const {t} = useTranslation('pages', {keyPrefix: 'space.settingsPage'});
  const {accentColor, hasDarkBg} = useThemeContext();

  const handleCopyAddressClick = (): void => {
    // Todo: add tracking here.
    navigator.clipboard.writeText(address).catch(trackError);
    setAddressCopied(true);
  };

  return (
    <div>
      <div className="mb-4 flex justify-between">
        <div>
          <Title content={t('walletAddress')} classes="text-lg" />
          <div className={classNames('text-sm', hasDarkBg ? 'text-white/60' : 'text-black/60')}>
            {address.slice(0, 10)}...{address.slice(-12)}
          </div>
        </div>
        <div>
          <SecondaryButton
            size="small"
            testId="space-settings-copy-btn"
            type="button"
            onClick={handleCopyAddressClick}
            text={
              addressCopied ? (
                <div className="flex items-center gap-x-1">
                  <Check size={16} />
                  {t('copied')}
                </div>
              ) : (
                t('copy')
              )
            }
            tracking={{namespace: 'settings.copyWalletAddress'}}
          />
        </div>
      </div>
      <div>
        <SecondaryButton
          testId="space-settings-import-digital-asset-btn"
          type="button"
          onClick={handleImportNftClick}
          text={
            <div className="flex items-center gap-x-2">
              <DownloadSimple size={16} style={{color: accentColor}} />
              {t('getDigitalAsset')}
            </div>
          }
          className="flex w-full justify-center px-12 md:block md:w-auto"
          tracking={{namespace: 'settings.importDigitalAsset'}}
        />
      </div>
    </div>
  );
};
